export const mediaServiceIsAuthenticated = (mediaServiceName: string) => {
	// @ts-ignore
	const mediaServices = (Netx as any).share.mediaServices;
	const mediaService = mediaServices?.find({name: mediaServiceName});
	return mediaService?.get('authenticated') === true;
};
